module.exports = __webpack_public_path__ + "static/red-onion-3b58df10feec11e48127f25737368d98.jpg";